// Grid 조회 버튼
const GridButtonBox = ({ title = '조회', btnStyle, onClick }) => {
    return (
        <button type='button' className={'btn grid ' + btnStyle} onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export default GridButtonBox;
